module.exports = ["NodeJS","ExpressJS","JavaScript","ES6/7","TypeScript","Python","Java","HTML","pug","handlebars","CSS","Stylus","Sass","Android","Ionic 2+","Openlayers 3+","Leaflet","Google Maps","Markdown","git","GitHub","PostgreSQL","PostGIS","Firebase","MongoDB","REST","GraphQL","..."]


//////////////////
// WEBPACK FOOTER
// ./src/files/tecnologias.json
// module id = 271
// module chunks = 1